module.exports = __webpack_public_path__ + "d75e6370295e046dd0b170ee42c3fa44.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-16.ttf
// module id = 1815
// module chunks = 0